import { render, staticRenderFns } from "./FinalWords.vue?vue&type=template&id=39477a6b&scoped=true&"
import script from "./FinalWords.vue?vue&type=script&lang=js&"
export * from "./FinalWords.vue?vue&type=script&lang=js&"
import style0 from "./FinalWords.vue?vue&type=style&index=0&id=39477a6b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39477a6b",
  null
  
)

export default component.exports